/**
 * This barrel file provides the export for the lazy loaded AboutComponent.
 */
export * from './rpw.component';
export * from './rpw.routes';



// WEBPACK FOOTER //
// ./src/app/resetPassword/index.ts